import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  { title: 'pages.onboarding.dataFrequency.nobody', value: 'nobody' },
  {
    title: 'pages.onboarding.dataFrequency.fewExperimenting',
    value: 'few-experimenting',
  },
  { title: 'pages.onboarding.dataFrequency.encouraged', value: 'encouraged' },
  { title: 'pages.onboarding.dataFrequency.integrated', value: 'integrated' },
  { title: 'pages.onboarding.dataFrequency.aiFirst', value: 'ai-first' },
]

export default function DataFrequencyPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.dataFrequency.title"
      layout="grid"
    />
  )
}
